export default{
    data(){
        return{
            reports:null,
        }
    }
}